/* nova-thumbs.js v5 — Mobile fix + thumbnail strip */

// ─── MOBILE LAYOUT FIX ───────────────────────────────────────────────────────
(function mobileFix() {
  function fix() {
    if (window.innerWidth > 989) return;

    var grid = document.querySelector('.product-information__grid');
    if (grid) {
      grid.style.setProperty('display', 'flex', 'important');
      grid.style.setProperty('flex-direction', 'column', 'important');
      grid.style.setProperty('width', '100%', 'important');
      grid.style.setProperty('max-width', '100%', 'important');
      grid.style.setProperty('box-sizing', 'border-box', 'important');
    }

    var media = document.querySelector('.product-information__media');
    if (media) {
      media.style.setProperty('padding', '0', 'important');
      media.style.setProperty('margin', '0', 'important');
      media.style.setProperty('width', '100%', 'important');
      media.style.setProperty('max-width', '100%', 'important');
      media.style.setProperty('overflow', 'hidden', 'important');
      media.style.setProperty('flex-direction', 'column', 'important');
      media.style.setProperty('align-items', 'stretch', 'important');
      media.style.setProperty('top', '0', 'important');
      media.style.setProperty('position', 'relative', 'important');
      media.style.setProperty('box-sizing', 'border-box', 'important');
    }

    var mg = document.querySelector('media-gallery');
    if (mg) {
      mg.style.setProperty('width', '100%', 'important');
      mg.style.setProperty('max-width', '100%', 'important');
      mg.style.setProperty('box-sizing', 'border-box', 'important');
    }

    document.querySelectorAll('slideshow-component').forEach(function(el) {
      el.style.setProperty('width', '100%', 'important');
      el.style.setProperty('max-width', '100%', 'important');
      el.style.setProperty('box-sizing', 'border-box', 'important');
    });

    var details = document.querySelector('.product-details');
    if (details) {
      details.style.setProperty('width', '100%', 'important');
      details.style.setProperty('max-width', '100%', 'important');
      details.style.setProperty('box-sizing', 'border-box', 'important');
    }

    var brandLabel = document.querySelector('[class*="nova_brand_label"]');
    if (brandLabel) brandLabel.style.setProperty('padding-top', '4px', 'important');

    // Fix thumb buttons: prevent media-gallery flex-grow from stretching them
    document.querySelectorAll('.nova-thumbs__btn').forEach(function(btn) {
      btn.style.setProperty('width', '60px', 'important');
      btn.style.setProperty('height', '60px', 'important');
      btn.style.setProperty('min-width', '60px', 'important');
      btn.style.setProperty('max-width', '60px', 'important');
      btn.style.setProperty('flex-grow', '0', 'important');
      btn.style.setProperty('flex-shrink', '0', 'important');
    });

    var thumbs = document.querySelector('.nova-thumbs');
    if (thumbs) {
      thumbs.style.setProperty('width', '100%', 'important');
      thumbs.style.setProperty('max-width', '100%', 'important');
      thumbs.style.setProperty('box-sizing', 'border-box', 'important');
      thumbs.style.setProperty('overflow-x', 'auto', 'important');
      thumbs.style.setProperty('gap', '4px', 'important');
      thumbs.style.setProperty('flex-grow', '0', 'important');
    }
  }

  fix();
  window.addEventListener('DOMContentLoaded', fix);
  window.addEventListener('load', fix);
  [100, 300, 700, 1500, 3000].forEach(function(ms) { setTimeout(fix, ms); });
  window.addEventListener('resize', fix);
})();

// ─── THUMBNAIL STRIP BUILDER ─────────────────────────────────────────────────
(function buildThumbs() {
  var ACCENT = '#8B6F47';
  var _building = false;

  function init() {
    if (_building) return;
    if (document.querySelector('.nova-thumbs')) return;

    var mediaEl = document.querySelector('.product-information__media');
    if (!mediaEl) return;
    var slideshow = mediaEl.querySelector('slideshow-component');
    if (!slideshow) return;

    var navTabs = Array.from(slideshow.querySelectorAll('button[aria-label]'))
      .filter(function(b) { return /^Slide \d+ of \d+$/.test(b.getAttribute('aria-label')); });
    if (navTabs.length < 2) return;

    _building = true;
    var handle = location.pathname.replace('/products/', '').split('?')[0].split('/')[0];

    fetch('/products/' + handle + '.js')
      .then(function(r) { return r.json(); })
      .then(function(product) {
        if (document.querySelector('.nova-thumbs')) { _building = false; return; }

        var images = (product.images || []).slice(0, navTabs.length);
        if (images.length < 2) { _building = false; return; }

        var isMobile = window.innerWidth <= 989;
        var btnSize = isMobile ? '60px' : '72px';

        var strip = document.createElement('div');
        strip.className = 'nova-thumbs';
        strip.style.cssText = 'display:flex;flex-wrap:nowrap;flex-grow:0;gap:' + (isMobile ? '4px' : '8px') + ';padding:8px 0;overflow-x:auto;width:100%;max-width:100%;box-sizing:border-box;scrollbar-width:none;-webkit-overflow-scrolling:touch;';

        images.forEach(function(imgUrl, i) {
          var btn = document.createElement('button');
          btn.className = 'nova-thumbs__btn';
          btn.type = 'button';
          btn.setAttribute('aria-label', 'View image ' + (i + 1));
          // flex-grow:0 and max-width prevent media-gallery from stretching buttons
          btn.style.cssText = 'width:' + btnSize + ';height:' + btnSize + ';min-width:' + btnSize + ';max-width:' + btnSize + ';flex-grow:0;flex-shrink:0;padding:2px;border:2px solid ' + (i === 0 ? ACCENT : 'transparent') + ';border-radius:4px;background:#f5f0eb;cursor:pointer;overflow:hidden;box-sizing:border-box;transition:border-color 0.2s;';

          var img = document.createElement('img');
          img.src = imgUrl;
          img.alt = product.title + ' ' + (i + 1);
          img.style.cssText = 'width:100%;height:100%;object-fit:cover;border-radius:2px;pointer-events:none;display:block;';
          img.loading = 'lazy';
          btn.appendChild(img);

          btn.addEventListener('click', function() {
            if (navTabs[i]) navTabs[i].click();
            document.querySelectorAll('.nova-thumbs__btn').forEach(function(b) {
              b.style.borderColor = 'transparent';
            });
            btn.style.borderColor = ACCENT;
          });

          strip.appendChild(btn);
        });

        slideshow.parentNode.insertBefore(strip, slideshow.nextSibling);
        _building = false;
      })
      .catch(function(err) { console.warn('[nova-thumbs] fetch failed:', err); _building = false; });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.addEventListener('load', function() { if (!document.querySelector('.nova-thumbs') && !_building) init(); });
  setTimeout(function() { if (!document.querySelector('.nova-thumbs') && !_building) init(); }, 2000);
})();


/* === NOVA TRUST BADGES === */
(function() {
  function injectTrustBadge() {
    if (document.querySelector('.nova-trust-badge')) return;
    const formButtons = document.querySelector('.product-form-buttons');
    if (!formButtons) return;

    const badge = document.createElement('div');
    badge.className = 'nova-trust-badge';
    badge.innerHTML = `
            <div class="nova-trust-badge__icons">
              <span class="nova-trust-badge__item">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect><path d="M7 11V7a5 5 0 0 1 10 0v4"></path></svg>
                Secure Checkout
              </span>
              <span class="nova-trust-badge__divider">·</span>
              <span class="nova-trust-badge__item">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
                Easy Returns
              </span>
            </div>
            <div class="nova-trust-badge__payments">
              <span class="nova-trust-badge__pay-label">We accept:</span>
              <span class="nova-trust-badge__pay-icon"><svg width="38" height="24" viewBox="0 0 38 24" xmlns="http://www.w3.org/2000/svg"><rect width="38" height="24" rx="4" fill="#1A1F71"/><text x="19" y="16" text-anchor="middle" fill="white" font-size="10" font-weight="800" font-family="Arial,sans-serif" letter-spacing="1">VISA</text></svg></span>
              <span class="nova-trust-badge__pay-icon"><svg width="38" height="24" viewBox="0 0 38 24" xmlns="http://www.w3.org/2000/svg"><rect width="38" height="24" rx="4" fill="white" stroke="#e0e0e0" stroke-width="1"/><circle cx="15" cy="12" r="7" fill="#EB001B"/><circle cx="23" cy="12" r="7" fill="#F79E1B"/><path d="M19 6.5a7 7 0 0 1 0 11A7 7 0 0 1 19 6.5z" fill="#FF5F00"/></svg></span>
              <span class="nova-trust-badge__pay-icon"><svg width="38" height="24" viewBox="0 0 38 24" xmlns="http://www.w3.org/2000/svg"><rect width="38" height="24" rx="4" fill="#007BC1"/><text x="19" y="16" text-anchor="middle" fill="white" font-size="8.5" font-weight="800" font-family="Arial,sans-serif" letter-spacing="0.5">AMEX</text></svg></span>
              <span class="nova-trust-badge__pay-icon"><svg width="38" height="24" viewBox="0 0 38 24" xmlns="http://www.w3.org/2000/svg"><rect width="38" height="24" rx="4" fill="white" stroke="#e0e0e0" stroke-width="1"/><text x="19" y="16" text-anchor="middle" font-size="9" font-weight="700" font-family="Arial,sans-serif"><tspan fill="#003087">Pay</tspan><tspan fill="#009CDE">Pal</tspan></text></svg></span>
            </div>
          `

    formButtons.insertAdjacentElement('afterend', badge);
  }

  // Inject styles
  if (!document.querySelector('style[data-nova-trust]')) {
    const style = document.createElement('style');
    style.setAttribute('data-nova-trust', '1');
    style.textContent = `
      .nova-trust-badge {
        margin-top: 16px;
        padding: 14px 16px;
        background: rgba(0,0,0,0.03);
        border: 1px solid rgba(0,0,0,0.08);
        border-radius: 8px;
        font-size: 12px;
        color: #555;
      }
      .nova-trust-badge__icons {
        display: flex;
        align-items: center;
        gap: 8px;
        flex-wrap: wrap;
        margin-bottom: 10px;
      }
      .nova-trust-badge__item {
        display: inline-flex;
        align-items: center;
        gap: 4px;
        font-weight: 500;
        color: #333;
        font-size: 11.5px;
      }
      .nova-trust-badge__item svg {
        opacity: 0.7;
        flex-shrink: 0;
      }
      .nova-trust-badge__divider {
        color: #ccc;
        font-size: 14px;
      }
      .nova-trust-badge__payments {
        display: flex;
        align-items: center;
        gap: 6px;
        flex-wrap: wrap;
      }
      .nova-trust-badge__pay-label {
        font-size: 11px;
        color: #888;
        margin-right: 2px;
      }
      .nova-trust-badge__pay-icon {
        display: inline-flex;
        align-items: center;
        margin: 0 2px;
      }
      .nova-trust-badge__pay-icon svg {
        display: block;
        border-radius: 4px;
        box-shadow: 0 1px 3px rgba(0,0,0,0.12);
      }
    `;
    document.head.appendChild(style);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectTrustBadge);
  } else {
    injectTrustBadge();
  }

  // Also watch for dynamic page changes (e.g. variant swaps)
  const obs = new MutationObserver(() => injectTrustBadge());
  obs.observe(document.body, { childList: true, subtree: true });
  setTimeout(() => obs.disconnect(), 5000);
})();
/* === END NOVA TRUST BADGES === */

// Hero tagline spacing fix
(function() {
  var style = document.createElement('style');
  style.textContent = '.hero__content-wrapper { padding-top: 60px !important; } @media (max-width: 749px) { .hero__content-wrapper { padding-top: 40px !important; } }';
  document.head.appendChild(style);
})();
